import React, { useState, useEffect, useRef, useContext } from "react";
import {
  Box,
  Tabs,
  Tab,
  IconButton,
  Switch,
  Typography,
  styled,
} from "@mui/material";
import Modal from "@mui/material/Modal";
import Slide from "@mui/material/Slide";
import CloseIcon from "@mui/icons-material/Close";
import Drawer from "@mui/material/Drawer";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Placeorder from "./Placeorder";
import Header from "../Header/Header1";
import { Drop, M1, M2, M3 } from "../../SvgCollection";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import PropTypes from "prop-types";
import TableRow from "@mui/material/TableRow";
import FormControlLabel from "@mui/material/FormControlLabel";
import Btcoin from "../../Img/btcoin.png";
import Tradeview from "./Tradeview";
import OrderBook from "./OrderBook";
import Orderhistory from "./orderhistory";
import Currentorders from "./currentorders";
import Tradehistorytab from "./tradehistorytab";
import Subscription from "./subscription";
import AssetView from "./AssetView";
import usercalls from "../../Axios";
import consts from "../../constant";
import { useLocation, useNavigate } from "react-router-dom";
import $ from "jquery";
import { useParams } from "react-router-dom";
import Context from "../../Context";
import Loader from "../Loader";
import axios from "axios";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import CandlestickChartIcon from "@mui/icons-material/CandlestickChart";
import { Helmet } from "react-helmet";
import Positions from "./Positions";
import io from "socket.io-client";
import ImageWithFallback from "../FallbackImage/ImageWithFallback";
import { toast, ToastContainer } from "react-toastify";

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 32,
  height: 18,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    left: "2px",
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#566FFF",
        ...theme.applyStyles("dark", {
          backgroundColor: "#177ddc",
        }),
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 14,
    height: 13,
    left: "2px",
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: "#ccc",
    boxSizing: "border-box",
    ...theme.applyStyles("dark", {
      backgroundColor: "rgba(255,255,255,.35)",
    }),
  },
}));

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const style = {
  position: "absolute",
  top: "12%",
  left: "0%", // Start from the left side of the screen
  transform: "translateY(-50%)", // Center vertically
  width: 600,
  bgcolor: "var(--model)",
  // border: '2px solid #000',
  borderRadius: "10px",
  boxShadow: 24,
  p: 2,
  "@media (max-width: 767.98px)": {
    width: "90% !important",
    left: "0%",
  },
};

const Trade2 = (props) => {
  const path = usercalls();
  const loaction = useLocation();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const theme = useTheme();
  const matchesXL = useMediaQuery(theme.breakpoints.up("lg"));
  const xl = useMediaQuery(theme.breakpoints.up("xl"));

  // get pair from url
  const { id } = useParams();

  //open orders count
  const {
    currentOrders,
    setPointFilter,
    setSelcOrderBook,
    openPositions,
    setMarkPrice,
    kucoinSocket,
    spotConnected,
    orderBookBits,
    setOrderBookBits,
    orderBookAsks,
    setOrderBookAsks,
  } = useContext(Context);

  const placeRoute = loaction.pathname?.split("/")[1];

  const sm = useMediaQuery(theme.breakpoints.up("sm"));

  const mobilemd = useMediaQuery(theme.breakpoints.up("md"));

  const [load, setLoad] = useState(false);
  const [openLayout, setOpenLayout] = useState(false);
  const toggleDrawerLayout = (newOpen) => () => {
    setOpenLayout(newOpen);
  };

  // State
  const [defLayout, setDefLayout] = useState("professional");

  const [professional, setProfessional] = useState(true);
  const [fullScreen, setFullScreen] = useState(false);
  const [classic, setClassic] = useState(false);
  const [binancesoc, setBinanceSoc] = useState();
  const [classicMark, setClassicMark] = useState(true);
  const [classicAsset, setClassicAsset] = useState(true);
  const [classicGleft, setClassicGleft] = useState(true);
  const [candle, setCandle] = useState(false);
  const [posTable, setPosTable] = useState("");

  const [pairsList, setPairsList] = useState([]);

  const [pairsLoading, setPairsLoading] = useState(false);

  const curSocPi = useRef();

  const handleCandle = () => {
    setCandle(!candle);
  };

  const handleLayoutType = (type) => {
    localStorage.setItem("layout", type);

    if (type === "professional") {
      setProfessional(true);
      setFullScreen(false);
      setClassic(false);
    } else if (type === "fullscreen") {
      setProfessional(false);
      setFullScreen(true);
      setClassic(false);
    } else if (type === "classic") {
      setProfessional(false);
      setFullScreen(false);
      setClassic(true);
    }
  };

  const [tradeComp, setTradeComp] = useState([
    { id: 0, label: <Currentorders />, visible: true },
    { id: 1, label: <Orderhistory />, visible: true },
    { id: 2, label: <Tradehistorytab />, visible: true },
    { id: 3, label: <Positions />, visible: true },
    // { id: 4, label: <Subscription />, visible: true },
  ]);

  const searchDebounceTimeout = useRef(null);
  const [currentPair, setCurrentPair] = useState();

  const [originalPairsList, setOriginalPairsList] = useState([]);
  // const [markPrice, setMarkPrice] = useState();

  // const [filterPoint, setFilterPoint] = useState(2)

  const [currentSocketws, setCurrentSocketws] = useState("");
  const [futureSocketToken, setFutureSocketToken] = useState("");

  const fetchPairsList = async (search, type) => {
    try {
      setLoad(true);
      setPairsList([]);
      setPairsLoading(true);
      var url;
      if (placeRoute == "future") {
        url = `${consts.BackendUrl
          }/getOwnFuturePairs?type=${quoteCoin}&search=${search ? search : ""}`;
      } else {
        url = `${consts.BackendUrl}/getOwnPairs?type=${quoteCoin}&search=${search ? search : ""
          }`;
      }

      var payload = {
        type: type,
        quoteCoin: quoteCoin,
      };
      const response = await path.getCall({ url, payload });
      const result = await response.json();
      if (result?.success == true) {
        // if ((search != undefined) && (search != "")) {
        //   var matchPairs = [];
        //   for (var i = 0; i < result?.result.length; i++) {
        //     var element = result?.result[i];
        //     if (new RegExp(`${search}`, "i").test(element?.baseCoin)) {
        //       matchPairs.push(element);
        //     }
        //   }
        //   if (matchPairs.length > 0) {
        //     setPairsList([...matchPairs]);
        //   } else {
        //     setPairsList();
        //   }
        // } else {
        setPairsList(result?.result);
        setLoad(false);
        if (type == "runs") {
          setOriginalPairsList(result?.result);
          handleSidebarSubscribe(result?.result);
          setLoad(false);
        }
        // getAxiosPairs(result?.result)
        result?.result?.forEach((pair) => {
          const symbol = pair?.pair_symbol?.split("_")?.join("");

          if (pair?.pair_symbol === id) {
            $(`.prices-${symbol}`).html(
              `<span class=${Number(pair?.last).toFixed(2) > 0 ? "tr-green" : "tr-red"
              } >${Number(pair?.last).toFixed(
                window.filterPoint ? window.filterPoint : 2
              )}</span>`
            );
            $(`.pricesses-${symbol}`).html(
              `<span class=${Number(pair?.last).toFixed(2) > 0 ? "tr-green" : "tr-red"
              } >${Number(pair?.last).toFixed(
                window.filterPoint ? window.filterPoint : 2
              )}</span>`
            );
            $(`.24hp-${symbol}`).html(
              `<span class=${Number(pair?.last).toFixed(2) > 0 ? "tr-green" : "tr-red"
              } >${Number(pair?.last).toFixed(2)}</span>`
            );
            $(`.24hpc-${symbol}`).html(
              `<span class=${Number(pair?.last).toFixed(2) > 0 ? "tr-green" : "tr-red"
              } >${Number(pair?.last).toFixed(2) + "%"}</span>`
            );
            // $(`.open-${symbol}`).html(Number(json?.o).toFixed(window.filterPoint ? window.filterPoint : 2));
            $(`.vol-${symbol}`).html(`<span >${Number(pair?.vol).toFixed(2)}`);
            $(`.high-${symbol}`).html(
              `<span >${Number(pair?.high).toFixed(
                window.filterPoint ? window.filterPoint : 2
              )}`
            );
            $(`.low-${symbol}`).html(
              `<span >${Number(pair?.low).toFixed(
                window.filterPoint ? window.filterPoint : 2
              )}`
            );
            setLoad(false);
          }
        });
        // }
        setLoad(false);
      } else {
        setPairsList([]);
        setLoad(false);
      }
      setPairsLoading(false);
    } catch (error) {
      setPairsLoading(false);
      setLoad(false);
      console.log("🚀 ~ fetchPairsList ~ error:", error);
    }
  };

  const getSinglePairDetails = async (id) => {
    try {
      setLoad(true);
      var url;
      if (placeRoute == "future") {
        url = `${consts.BackendUrl}/getOwnSinglePair`;
      } else {
        url = `${consts.BackendUrl}/getOwnSinglePair`;
      }

      var payload = {
        pair: id,
        type: "futures",
      };
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      if (result?.success == true) {
        if (placeRoute == "future") {
          $(`.prices-${result?.result?.symbol}`).html(
            `<span  >${Number(result?.result?.lastTradePrice).toFixed(
              window.filterPoint ? window.filterPoint : 2
            )}</span>`
          );

          $(`.pricesses-${result?.result?.symbol}`).html(
            `<span > ${Number(result?.result?.lastTradePrice)}</span>`
          );

          setMarkPrice(Number(result?.result?.markPrice));

          $(`.markPrice`).html(
            `<span > ${Number(result?.result?.markPrice)}</span>`
          );

          $(`.indexPrice`).html(
            `<span > ${Number(result?.result?.indexPrice)}</span>`
          );

          $(`.24hpc-${result?.result?.symbol}`).html(
            `<span class=${Number(result?.result?.priceChgPct * 100).toFixed(2) > 0
              ? "tr-green"
              : "tr-red"
            } >${Number(result?.result?.priceChgPct * 100).toFixed(2) + "%"
            }</span>`
          );

          $(`.vol-${result?.result?.symbol}`).html(
            Number(result?.result?.volumeOf24h).toFixed(2)
          );

          $(`.high-${result?.result?.symbol}`).html(
            Number(result?.result?.highPrice).toFixed(
              window.filterPoint ? window.filterPoint : 2
            )
          );

          $(`.low-${result?.result?.symbol}`).html(
            Number(result?.result?.lowPrice).toFixed(
              window.filterPoint ? window.filterPoint : 2
            )
          );
          setLoad(false);
        } else {
          $(`.prices-${result?.result?.symbol?.split("-").join("")}`).html(
            `<span  >${Number(result?.result?.last).toFixed(
              window.filterPoint ? window.filterPoint : 2
            )}</span>`
          );

          $(`.pricesses-${result?.result?.symbol?.split("-").join("")}`).html(
            `<span > ${Number(result?.result?.last).toFixed(
              window.filterPoint ? window.filterPoint : 2
            )}</span>`
          );

          $(`.24hpc-${result?.result?.symbol?.split("-").join("")}`).html(
            `<span class=${Number(result?.result?.changeRate * 100).toFixed(2) > 0
              ? "tr-green"
              : "tr-red"
            } >${Number(result?.result?.changeRate * 100).toFixed(2) + "%"
            }</span>`
          );

          $(`.volbase-${result?.result?.symbol?.split("-").join("")}`).html(
            Number(result?.result?.vol).toFixed(2)
          );

          $(`.high-${result?.result?.symbol?.split("-").join("")}`).html(
            Number(result?.result?.high).toFixed(
              window.filterPoint ? window.filterPoint : 2
            )
          );

          $(`.low-${result?.result?.symbol?.split("-").join("")}`).html(
            Number(result?.result?.low).toFixed(
              window.filterPoint ? window.filterPoint : 2
            )
          );
          setLoad(false);
        }
      }
      setLoad(false);
    } catch (error) {
      console.log("🚀 ~ getSinglePairDetails ~ error:", error);
      setLoad(false);
    }
  };

  // const generatekucointoken = async () => {
  //   try {
  //     axios.withCredentials = true;
  //     const url = `${consts.BackendUrl}/kucoin/generatekucointoken`;
  //     const { data } = await axios.get(url);
  //     if (data.success) {
  //       let str = data?.result?.replace(/^"(.*)"$/, "$1");
  //       setFutureSocketToken(str);
  //       console.log(str, "kucoinToken");
  //     }
  //   } catch (err) {
  //     console.log(err, "error from token");
  //   }
  // };

  // const currentSocket = async (id) => {
  //   try {
  //     const ws = new WebSocket("wss://stream.binance.com:9443/ws");
  //     setCurrentSocketws(ws)
  //     ws.onopen = (event) => {
  //       const symbols = `${id?.split("_")?.join("")?.toLowerCase()}@ticker`
  //       const priceApicall = {
  //         "method": "SUBSCRIBE",
  //         "params": [symbols],
  //         "id": 1
  //       }

  //       ws.send(JSON.stringify(priceApicall));
  //     };

  //     ws.onmessage = function (event) {
  //       const json = JSON.parse(event.data);
  //       // console.log(window.filterPoint, "window.filterPointwindow.filterPoint")
  //       try {
  //         $(`.prices-${json?.s}`).html(`<span class=${Number(json?.P).toFixed(2) > 0 ? 'tr-green' : 'tr-red'} >${Number(json?.c).toFixed(window.filterPoint ? window.filterPoint : 2)}</span>`);
  //         $(`.24hp-${json?.s}`).html(`<span class=${Number(json?.P).toFixed(2) > 0 ? 'tr-green' : 'tr-red'} >${Number(json?.p).toFixed(2)}</span>`);
  //         $(`.24hpc-${json?.s}`).html(`<span class=${Number(json?.P).toFixed(2) > 0 ? 'tr-green' : 'tr-red'} >${Number(json?.P).toFixed(2) + "%"}</span>`);
  //         $(`.open-${json?.s}`).html(Number(json?.o).toFixed(window.filterPoint ? window.filterPoint : 2));
  //         $(`.vol-${json?.s}`).html(Number(json?.v).toFixed(2));
  //         $(`.high-${json?.s}`).html(Number(json?.h).toFixed(window.filterPoint ? window.filterPoint : 2));
  //         $(`.low-${json?.s}`).html(Number(json?.l).toFixed(window.filterPoint ? window.filterPoint : 2));
  //         if (json?.c != undefined) {
  //           setMarkPrice(json?.c);
  //         }
  //       } catch (error) {
  //         console.log(error, 'err');

  //       }
  //     };

  //     ws.onerror = (error) => {
  //       console.error('WebSocket Error:', error);
  //     };

  //     ws.onclose = () => {
  //       console.log('WebSocket Connection Closed');
  //     };

  //     return () => {
  //       console.log('Cleaning up WebSocket connection');
  //       ws.close();
  //     };
  //   } catch (error) {
  //     console.log("🚀 ~ currentSocket ~ error:", error)
  //   }
  // }

  // const currentFutureSocket = async (id) => {
  //   try {
  //     // const ws = new WebSocket(`wss://fstream.binance.com/ws/${symbols}`);
  //     const ws = new WebSocket(
  //       `wss://ws-api-futures.kucoin.com?token=${futureSocketToken}`
  //     );
  //     setCurrentSocketws(ws);
  //     ws.onopen = (event) => {
  //       const pairs = pairsList?.map(
  //         (pair) => pair.pair_symbol?.split("_").join("") + "M"
  //       );
  //       const merge = [id?.split("_")?.join("") + "M", ...pairs];
  //       const symbols = merge.join(",");
  //       // console.log(symbols)
  //       const priceApicall = {
  //         "id": new Date().getTime(),
  //         "type": "subscribe",
  //         "topic": `/contractMarket/snapshot:${symbols}`,
  //         "response": true
  //       }
  //       const instrumentApicall = {
  //         "id": new Date().getTime() + 1, // ensure different ID
  //         "type": "subscribe",
  //         "topic": `/contract/instrument:${id?.split("_")?.join("") + "M"}`,
  //         "response": true
  //       };

  //       if (pairsList.length > 0 && futureSocketToken) {
  //         ws.send(JSON.stringify(priceApicall));
  //         ws.send(JSON.stringify(instrumentApicall));
  //         // console.log("web socket open futures")
  //       }
  //     };
  //     ws.onmessage = function (event) {
  //       const json = JSON.parse(event.data);
  //       const symbol = json?.data?.symbol?.slice(0, -1);
  //       // console.log(window.filterPoint, "window.filterPointwindow.filterPoint")
  //       try {

  //         if (json?.subject == "mark.index.price") {
  //           $(`.markPrice`).html(`<span > ${Number(json?.data?.markPrice)} </span>`);
  //           $(`.mark-pricesses-${json?.topic?.split(':')[1]}`).html(`<span > ${Number(json?.data?.markPrice)} </span>`);
  //           setMarkPrice(Number(json?.data?.markPrice));
  //           $(`.indexPrice`).html(`<span > ${Number(json?.data?.indexPrice)} </span>`);
  //         } else {
  //           $(`.prices-${symbol}`).html(`<span class=${Number(json?.data?.lastPrice).toFixed(2) > 0 ? 'tr-green' : 'tr-red'} >${Number(json?.data?.lastPrice).toFixed(window.filterPoint ? window.filterPoint : 2)}</span>`);
  //           $(`.pricesses-${symbol}`).html(`<span class=${Number(json?.data?.lastPrice).toFixed(2) > 0 ? 'tr-green' : 'tr-red'} >${Number(json?.data?.lastPrice).toFixed(window.filterPoint ? window.filterPoint : 2)}</span>`);
  //           $(`.24hp-${symbol}`).html(`<span class=${Number(json?.data?.priceChgPct).toFixed(2) > 0 ? 'tr-green' : 'tr-red'} >${Number(json?.data?.priceChgPct).toFixed(2)}</span>`);
  //           $(`.24hpc-${symbol}`).html(`<span class=${Number(json?.data?.priceChgPct).toFixed(2) > 0 ? 'tr-green' : 'tr-red'} >${Number(json?.data?.priceChgPct).toFixed(2) + "%"}</span>`);
  //           // $(`.open-${symbol}`).html(Number(json?.o).toFixed(window.filterPoint ? window.filterPoint : 2));
  //           $(`.vol-${symbol}`).html(`<span >${Number(json?.data?.volume).toFixed(2)}</span>`);
  //           $(`.high-${symbol}`).html(`<span >${Number(json?.data?.highPrice).toFixed(window.filterPoint ? window.filterPoint : 2)}</span>`);
  //           $(`.low-${symbol}`).html(`<span >${Number(json?.data?.lowPrice).toFixed(window.filterPoint ? window.filterPoint : 2)}</span>`);
  //           $(`.price-${symbol}`).html(`<span > ${Number(json?.data?.lastPrice).toFixed(6)} </span>`);
  //           $(`.24hrchange-${symbol}`).html(
  //             `<span class=${Number(json?.data?.priceChgPct).toFixed(2) >= 0
  //               ? 'tr-green' : 'tr-red'} >${Number(json?.data?.priceChgPct).toFixed(2) + "%"}</span>`);
  //           // if (json?.lastPrice != undefined) {
  //           //   setMarkPrice(json?.lastPrice);
  //           // }
  //         }
  //       } catch (error) {
  //         console.log(error, "err");
  //       }
  //     };

  //     ws.onerror = (error) => {
  //       console.error("WebSocket Error:", error);
  //     };

  //     ws.onclose = () => {
  //       console.log("WebSocket Connection Closed futures");
  //     };

  //     return () => {
  //       console.log("Cleaning up WebSocket connection");
  //       ws.close();
  //     };
  //   } catch (error) {
  //     console.log("🚀 ~ currentSocket ~ error:", error);
  //   }
  // };

  useEffect(() => {
    if (classicMark || classicAsset) {
      setClassicGleft(true);
    } else {
      setClassicGleft(false);
    }
  }, [classicMark, classicAsset]);

  // useEffect(() => {
  //   generatekucointoken();
  // }, []);

  useEffect(() => {
    if (id) {
      // if (currentSocketws) {
      //   currentSocketws.close();
      // }
      setCurrentPair(id);
      getSinglePairDetails(id);
      //   if (placeRoute == "future") {
      //     currentFutureSocket(id);
      //   } else {
      //     // currentSocket(id)
      //   }
      // }

      // curSocPi.current = setInterval(() => {
      //   if (currentSocketws?.readyState === WebSocket.OPEN) {
      //     const pingMsg = {
      //       id: `ping-${Date.now()}`,
      //       type: "ping",
      //     };
      //     currentSocketws?.send(JSON.stringify(pingMsg));
      //     // console.log('Sent ping:', pingMsg.id);
      //   }
      // }, 20000); // every 20 seconds

      // return () => {
      //   clearInterval(curSocPi.current);
    }
  }, [id, placeRoute]);

  function formatNumber(num) {
    if (num >= 1_000_000) {
      return (num / 1_000_000).toFixed(2) + "M"; // Convert to Million
    } else if (num >= 1_000) {
      return (num / 1_000).toFixed(2) + "K"; // Convert to Thousand
    } else {
      return num.toString(); // Return as is if < 1,000
    }
  }

  let lastUpdateTime = 0;

  const prevIdRef = useRef("");

  useEffect(() => {
    // console.log(spotConnected, id, kucoinSocket?.current, "testiudfhuisd")
    if (!spotConnected || !id || !kucoinSocket?.current) return;

    const prevId = prevIdRef.current;
    const mergeCurrent = id.split("_").join("").toUpperCase() + "M";
    const currentTopic = `/contractMarket/snapshot:${mergeCurrent}`;

    const unsubscribeTopic = (symbolId) => {
      if (symbolId && kucoinSocket.current?.readyState === WebSocket.OPEN) {
        const formatted = symbolId.split("_").join("").toUpperCase() + "M";
        // console.log("🚀 ~ unsubscribeTopic ~ formatted:", formatted)
        const topic = `/contractMarket/snapshot:${formatted}`;
        const msg = {
          id: Date.now(),
          type: "unsubscribe",
          topic,
          response: true,
        };
        const instrumentApicall = {
          id: new Date().getTime() + 1, // ensure different ID
          type: "unsubscribe",
          topic: `/contract/instrument:${formatted}`,
          response: true,
        };
        kucoinSocket.current.send(JSON.stringify(msg));
        kucoinSocket.current.send(JSON.stringify(instrumentApicall));
        console.log("🛑 Unsubscribed futures:", topic);
      }
    };

    const subscribeTopic = () => {
      if (kucoinSocket.current?.readyState === WebSocket.OPEN) {
        const msg = {
          id: Date.now(),
          type: "subscribe",
          topic: currentTopic,
          response: true,
        };
        const instrumentApicall = {
          id: new Date().getTime() + 1, // ensure different ID
          type: "subscribe",
          topic: `/contract/instrument:${mergeCurrent}`,
          response: true,
        };

        kucoinSocket.current.send(JSON.stringify(msg));
        kucoinSocket.current.send(JSON.stringify(instrumentApicall));
        // console.log("✅ Subscribed futures:", currentTopic);
      }
    };

    const handleMessage = (event) => {
      const res = JSON.parse(event.data);
      const json = res?.data ?? null;
      const topic = res?.topic;

      if (!json || !topic) return;

      const symbol = topic.split(":")[1].replace(/-/g, "");
      // console.log("🚀 ~ handleMessage ~ symbol futures:", symbol, json)
      setLoad(true);
      if (json?.asks && json?.bids) {
        // console.log("🚀 ~ handleMessage ~ symbol:", symbol, json)
        const now = Date.now();
        const oneSecond = 1000;
        // console.log(json)
        // Only process if 1 second has passed since last update
        setLoad(false);
        if (now - lastUpdateTime >= oneSecond) {
          lastUpdateTime = now;
          var bits = json?.asks;
          var asks = json?.bids;
          const updatedBits = bits?.map(([price, quantity]) => {
            const total = parseFloat(price) * parseFloat(quantity);
            return [
              price,
              quantity,
              total,
              formatNumber(parseFloat(quantity)),
              formatNumber(total.toFixed(3)),
            ];
          });
          if (bits?.length > 0) {
            setOrderBookBits((prevArray) => {
              // Concatenate the previous array with the new bits, sort in descending order, and slice the first 20 elements
              const updatedArray = [...updatedBits, ...prevArray]
                .slice(0, 20)
                .sort((a, b) => parseFloat(b[0]) - parseFloat(a[0]));
              return updatedArray;
            });
          }
          const updatedAsks = asks?.map(([price, quantity]) => {
            const total = parseFloat(price) * parseFloat(quantity);
            return [
              price,
              quantity,
              total,
              formatNumber(parseFloat(quantity)),
              formatNumber(total.toFixed(3)),
            ];
          });
          if (asks?.length > 0) {
            setOrderBookAsks((prevArray) => {
              // Concatenate the previous array with the new asks, sort in descending order, and slice the first 20 elements
              const updatedArray = [...updatedAsks, ...prevArray].slice(0, 20);
              return updatedArray;
            });
          }

          // ✅ Do something with the data here
          // console.log('Processed WebSocket data:');
        }
        setLoad(false);
      } else {
        setLoad(true);
        if (res?.subject == "mark.index.price") {
          $(`.markPrice`).html(`<span > ${Number(json?.markPrice)} </span>`);
          $(`.mark-pricesses-${json?.topic?.split(":")[1]}`).html(
            `<span > ${Number(json?.markPrice)} </span>`
          );
          setMarkPrice(Number(json?.markPrice));
          $(`.indexPrice`).html(`<span > ${Number(json?.indexPrice)} </span>`);
        } else if (json?.lastPrice) {
          $(`.prices-${symbol}`).html(
            `<span class=${(Number(json?.priceChgPct) * 100).toFixed(2) > 0
              ? "tr-green"
              : "tr-red"
            } >${Number(json?.lastPrice).toFixed(
              window.filterPoint ? window.filterPoint : 2
            )}</span>`
          );
          $(`.pricesses-${symbol}`).html(
            `<span >${Number(json?.lastPrice).toFixed(
              window.filterPoint ? window.filterPoint : 2
            )}</span>`
          );
          $(`.24hp-${symbol}`).html(
            `<span class=${(Number(json?.priceChgPct) * 100).toFixed(2) > 0
              ? "tr-green"
              : "tr-red"
            } >${(Number(json?.priceChgPct) * 100).toFixed(2)}</span>`
          );
          $(`.24hpc-${symbol}`).html(
            `<span class=${(Number(json?.priceChgPct) * 100).toFixed(2) > 0
              ? "tr-green"
              : "tr-red"
            } > ${(Number(json?.priceChgPct) * 100).toFixed(2) + "%"}</span > `
          );
          // $(`.open - ${ symbol } `).html(Number(json?.o).toFixed(window.filterPoint ? window.filterPoint : 2));
          $(`.vol-${symbol} `).html(
            `<span> ${Number(json?.volume).toFixed(2)}</span > `
          );
          $(`.high-${symbol} `).html(
            `<span> ${Number(json?.highPrice).toFixed(
              window.filterPoint ? window.filterPoint : 2
            )}</span > `
          );
          $(`.low-${symbol} `).html(
            `<span> ${Number(json?.lowPrice).toFixed(
              window.filterPoint ? window.filterPoint : 2
            )}</span > `
          );
          $(`.price-${symbol} `).html(
            `<span> ${Number(json?.lastPrice)} </span > `
          );
          $(`.24hrchange-${symbol} `).html(
            `<span class=${Number(json?.priceChgPct * 100).toFixed(2) >= 0
              ? "tr-green"
              : "tr-red"
            }> ${Number(json?.priceChgPct * 100).toFixed(2) + "%"}</span>`
          );
        }
        setLoad(false);
      }

      // Update UI (jQuery or React)
    };

    kucoinSocket.current.onmessage = handleMessage;

    if (kucoinSocket.current.readyState === WebSocket.OPEN) {
      unsubscribeTopic(prevId); // unsubscribe old
      subscribeTopic(); // subscribe new
    } else {
      kucoinSocket.current.onopen = () => {
        unsubscribeTopic(prevId);
        subscribeTopic();
      };
    }

    prevIdRef.current = id;

    return () => {
      // Always unsubscribe current topic on unmount
      unsubscribeTopic(id);

      // Cleanup handlers
      if (kucoinSocket.current) {
        kucoinSocket.current.onopen = null;
        kucoinSocket.current.onmessage = null;
        kucoinSocket.current.onerror = null;
        kucoinSocket.current.onclose = null;
      }
    };
  }, [spotConnected, id, kucoinSocket.current]);

  const sidebarSubscribedRef = useRef(false);

  const handleSidebarSubscribe = (pairsList) => {
    setLoad(true);
    if (
      !kucoinSocket.current ||
      kucoinSocket.current.readyState !== WebSocket.OPEN
    )
      return;
    if (sidebarSubscribedRef.current) return; // already subscribed

    const symbols = pairsList
      .map((pair) => pair.pair_symbol?.split("_").join("").toUpperCase() + "M")
      .join(",");

    const topic = `/contractMarket/snapshot:${symbols}`;
    const subscribeMsg = {
      id: Date.now(),
      type: "subscribe",
      topic,
      response: true,
    };

    kucoinSocket.current.send(JSON.stringify(subscribeMsg));
    console.log("📡 Subscribed to sidebar pairs123:", topic);
    sidebarSubscribedRef.current = true;
    setLoad(false);
  };

  const handleSidebarUnsubscribe = () => {
    setLoad(true);
    if (
      !kucoinSocket.current ||
      kucoinSocket.current.readyState !== WebSocket.OPEN
    )
      return;
    if (!sidebarSubscribedRef.current) return; // already unsubscribed

    const currentSymbol = id?.split("_")?.join("")?.toUpperCase() + "M";

    const symbols = originalPairsList
      ?.filter(
        (pair) =>
          pair.pair_symbol?.split("_")?.join("")?.toUpperCase() + "M" !==
          currentSymbol
      )
      ?.map(
        (pair) => pair.pair_symbol?.split("_")?.join("")?.toUpperCase() + "M"
      )
      ?.join(",");

    const topic = `/contractMarket/snapshot:${symbols}`;
    const unsubscribeMsg = {
      id: Date.now(),
      type: "unsubscribe",
      topic,
      response: true,
    };

    kucoinSocket.current.send(JSON.stringify(unsubscribeMsg));
    console.log("🛑 Unsubscribed from sidebar pairs futures:", topic);
    sidebarSubscribedRef.current = false;
    setLoad(false);
  };

  const [activeTab, setActiveTab] = useState(0); // Active tab index

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const [activeTab2, setActiveTab2] = useState(0); // Active tab index

  const handleTabChange2 = (event, newValue) => {
    setActiveTab2(newValue);
  };

  const [activeTab3, setActiveTab3] = useState(0); // Active tab index
  const [ativeDiv, setActiveDiv] = useState(0);

  const [activeTab4, setActiveTab4] = useState(0);

  const handleTabChange4 = (event, newValue) => {
    setActiveTab4(newValue);
  };

  const [activeTab5, setActiveTab5] = useState(0);

  const handleTabChange5 = (event, newValue) => {
    setActiveTab5(newValue);
  };

  const [quoteCoin, setQuoteCoin] = useState("USDT");
  const [type, setType] = useState("spot");

  const [openCoinPair, setOpenCoinPair] = useState(false);
  const handleOpenCoinPair = (val) => {
    setOpenCoinPair(true);
  };
  const handleCloseCoinPair = () => {
    setOpenCoinPair(false);
  };

  const [valueTab2, setValueTab2] = useState(0);

  const handleChangeTab2 = (event, newValue) => {
    const tabLabels = ["spot", "future", "spot"];
    setValueTab2(newValue);
    setType(tabLabels[newValue]);
  };

  const [value7, setValue7] = useState(0);

  const handleChange7 = (event, newValue) => {
    const tabLabels = ["USDT", "USDC", "BTC", "ETH"];
    setValue7(newValue);
    setQuoteCoin(tabLabels[newValue]);
  };

  // const subscribePair = async () => {
  //   try {
  //     const ws = new WebSocket("wss://stream.binance.com:9443/ws");
  //     setBinanceSoc(ws)
  //     ws.onopen = (event) => {
  //       const symbols = pairsList?.map(data => `${ data?.pair_symbol?.split("_")?.join("")?.toLowerCase() } @ticker`);
  //       const priceApicall = {
  //         "method": "SUBSCRIBE",
  //         "params": symbols,
  //         "id": 1
  //       }
  //       ws.send(JSON.stringify(priceApicall));
  //     };

  //     ws.onmessage = function (event) {
  //       const json = JSON.parse(event.data);
  //       try {
  //         $(`.price-${ json?.s } `).html(` < span > ${ Number(json?.c).toFixed(6) } </span > `);
  //         $(`.24hrchange - ${ json?.s } `).html(` < span class=${ Number(json?.P).toFixed(2) >= 0 ? 'tr-green' : 'tr-red' } > ${ Number(json?.P).toFixed(2) + "%" }</span > `);
  //       } catch (error) {
  //         console.log(error, 'err');
  //       }
  //     };

  //     ws.onerror = (error) => {
  //       console.error('WebSocket Error:', error);
  //     };

  //     ws.onclose = () => {
  //       console.log('WebSocket Connection Closed');
  //     };

  //     return () => {
  //       console.log('Cleaning up WebSocket connection');
  //       ws.close();
  //     };
  //   } catch (error) {
  //     console.log("🚀 ~ subscribePair ~ error:", error)
  //   }
  // }

  // const subscribeFuturePair = async () => {
  //   try {
  //     const ws = new WebSocket(`ss://ws-api-futures.kucoin.com?token=${futureSocketToken}`);
  //     setBinanceSoc(ws)
  //     ws.onopen = (event) => {
  //     };

  //     ws.onmessage = function (event) {
  //       const json = JSON.parse(event.data);
  //       try {
  //         for (let i = 0; i < json.length; i++) {
  //           const element = json[i];
  //           $(`.price-${element?.s}`).html(`<span > ${Number(element?.c).toFixed(6)} </span>`);
  //           $(`.24hrchange-${element?.s}`).html(`<span class=${Number(element?.P).toFixed(2) >= 0 ? 'tr-green' : 'tr-red'} >${Number(element?.P).toFixed(2) + "%"}</span>`);
  //         }
  //       } catch (error) {
  //         console.log(error, 'err');
  //       }
  //     };

  //     ws.onerror = (error) => {
  //       console.error('WebSocket Error:', error);
  //     };

  //     ws.onclose = () => {
  //       console.log('WebSocket Connection Closed');
  //     };

  //     return () => {
  //       console.log('Cleaning up WebSocket connection');
  //       ws.close();
  //     };
  //   } catch (error) {
  //     console.log("🚀 ~ subscribePair ~ error:", error)
  //   }
  // }

  // const unSubscribePair = async () => {
  //   try {
  //     if (binancesoc) {
  //       binancesoc?.close()
  //     }
  //   } catch (error) {
  //     console.log("🚀 ~ unSubscribePair ~ error:", error)
  //   }
  // }

  const handleSearch = async (search) => {
    if (searchDebounceTimeout.current) {
      clearTimeout(searchDebounceTimeout.current);
    }

    searchDebounceTimeout.current = setTimeout(() => {
      fetchPairsList(search);
    }, 500);
  };

  function countDecimals(num) {
    // Convert to string if it's a number
    // let strNum = typeof num === "number" ? num.toString() : num;

    // if (!strNum?.includes(".")) return 0; // No decimal point means 0 decimals

    // Trim trailing zeros to count only significant decimal places
    window.filterPoint = num;
    window.localStorage.setItem("pointFilter", num);
    return num;
  }

  // const getAxiosPairs = async (currentPairs) => {
  //   try {
  //     if (currentPairs?.length > 0) {
  //       const symbols = currentPairs?.map(data => data?.pair_symbol?.split("_")?.join(""));
  //       var data
  //       if (placeRoute == "future") {
  //         const dts = await axios.get(`https://testnet.binancefuture.com/fapi/v2/ticker/price?symbols=${JSON.stringify(symbols)}`)
  //         data = dts.data
  //       } else {
  //         const dts = await axios.get(`https://api.binance.com/api/v3/ticker/24hr?symbols=${JSON.stringify(symbols)}`)
  //         data = dts.data
  //       }
  //       if (data?.length > 0) {
  //         for (let i = 0; i < data?.length; i++) {
  //           const element = data[i];
  //           let priceHtml = parseFloat(element?.priceChangePercent).toFixed(2) > 0 ?
  //             `<span class="green" > +${parseFloat(element?.priceChangePercent).toFixed(2)} %</span> ` :
  //             `<span class="red" > ${parseFloat(element?.priceChangePercent).toFixed(2)} %</span> `;

  //           // class=${Number(element?.priceChangePercent).toFixed(2) >= 0 ? 'tr-green' : 'tr-red'}
  //           $(`.price-${element?.symbol}`).html(`<span  > ${Number(element?.lastPrice).toFixed(6)} </span>`);
  //           $(`.24hrchange-${element?.symbol}`).html(`<span class=${Number(element?.priceChangePercent).toFixed(2) >= 0 ? 'tr-green' : 'tr-red'} >${Number(element?.priceChangePercent).toFixed(2) + "%"}</span>`);

  //           // $(`.price-${element?.symbol}`).html(isNaN(element?.lastPrice) ? '0' : Number(element?.lastPrice).toFixed(6));
  //           // $(`.24hrchange-${element?.symbol}`).html(priceHtml);
  //         }
  //       }
  //     }
  //   } catch (error) {
  //     console.log(error, "error")
  //   }
  // }

  // useEffect(() => {
  //   fetchPairsList();
  // }, [type, quoteCoin, placeRoute]);

  // useEffect(() => {
  //   if (pairsList?.length > 0) {
  //     unSubscribePair()
  //     if (placeRoute == "future") {
  //       subscribeFuturePair()
  //     } else {
  //       subscribePair()
  //     }
  //   }
  // }, [pairsList])

  const midpoint = Math.floor(pairsList.length / 2);

  const [tabs, setTabs] = useState([
    { id: 1, label: "Chart", visible: true },
    { id: 2, label: "Market depth", visible: true },
    { id: 3, label: "Order Book", visible: matchesXL ? false : true },
    // { id: 4, label: "Recent order", visible: matchesXL ? false : true },
  ]);

  const [tabs2, setTabs2] = useState([
    { id: 1, label: "Order Book", visible: true },
    // { id: 2, label: "Recent order", visible: true },
    // { id: 3, label: "Tab 3", visible: true },
  ]);

  const [tabs3, setTabs3] = useState([
    // classic && { id: 4, label: "Place Order)", visible: true },
    { id: 0, label: `current orders`, visible: true },
    { id: 1, label: "order history", visible: true },
    { id: 2, label: "trade history", visible: true },
    // { id: 3, label: "redemption history", visible: true },
    { id: 3, label: "Positions", visible: true },
    // { id: 4, label: "Place Order", visible: true }
  ]);

  const [tabs4, setTabs4] = useState([
    { id: 1, label: "place order", visible: true },
    // { id: 2, label: "Tab 2", visible: true },
    // { id: 3, label: "Tab 3", visible: true },
  ]);

  const [tabs5, setTabs5] = useState([
    { id: 1, label: "Asset Overview", visible: true },
    // { id: 2, label: "Tab 2", visible: true },
    // { id: 3, label: "Tab 3", visible: true },
  ]);

  const handleTabMath = (id) => {
    // alert(activeTab,'activeTabchek');

    if (id === 2 && activeTab === 0) {
      setActiveTab(0);
    } else if (id === 1 && activeTab === 0) {
      setActiveTab(1);
    } else if (id === 2 && activeTab === 1) {
      setActiveTab(0);
    } else if (id === 1 && activeTab === 1) {
      setActiveTab(1);
    }
  };

  const handleTabMath2 = (id) => {
    if (id === 2 && activeTab2 === 0) {
      setActiveTab2(0);
    } else if (id === 1 && activeTab2 === 0) {
      setActiveTab2(1);
    } else if (id === 2 && activeTab2 === 1) {
      setActiveTab2(0);
    } else if (id === 1 && activeTab2 === 1) {
      setActiveTab2(1);
    }
  };
  const handleTabMath3 = (id, i) => {
    //  setActiveTab3(id)
    if (activeTab3 >= id) {
      setActiveTab3(activeTab3 - 1);
      setActiveDiv(activeTab3 - 1);
    }
  };

  const handleLayoutIndex = (i, visible) => {
    if (i === 0 && visible === true) {
      setActiveTab(1);
    } else {
      setActiveTab(0);
    }
  };

  const handleLayoutIndex2 = (i, visible) => {
    if (i === 0 && visible === true) {
      setActiveTab2(1);
    } else {
      setActiveTab2(0);
    }
  };

  const handleLayoutIndex3 = (i, id) => {
    if (ativeDiv === id) {
      // Find the next visible tab after the current index
      const nextVisibleTab = tabs3.slice(id + 1).find((tab) => tab.visible);

      if (nextVisibleTab) {
        setActiveTab3(nextVisibleTab.id);
        setActiveDiv(nextVisibleTab.id);
      } else {
        // If no visible tab after the current one, find one before it
        const prevVisibleTab = tabs3
          .slice(0, id)
          .reverse()
          .find((tab) => tab.visible);
        if (prevVisibleTab) {
          setActiveTab3(prevVisibleTab.id);
          setActiveDiv(prevVisibleTab.id);
        } else {
          // If no visible tabs at all, set both to null
          setActiveTab3(null);
          setActiveDiv(null);
        }
      }
    }
  };
  const handleCloseTab = (id) => {
    setTabs(
      tabs.map((tab) => (tab.id === id ? { ...tab, visible: false } : tab))
    );
    if (id === 2 && activeTab === 0) {
      setActiveTab(0);
    } else if (id === 1 && activeTab === 0) {
      setActiveTab(1);
    } else if (id === 2 && activeTab === 1) {
      setActiveTab(0);
    } else if (id === 1 && activeTab === 1) {
      setActiveTab(1);
    }
  };

  const handleToggleTab = (id) => {
    setTabs(
      tabs.map((tab) =>
        tab.id === id ? { ...tab, visible: !tab.visible } : tab
      )
    );
  };

  const handleCloseTab2 = (id) => {
    setTabs2(
      tabs2.map((tab) => (tab.id === id ? { ...tab, visible: false } : tab))
    );
  };

  const handleToggleTab2 = (id) => {
    setTabs2(
      tabs2.map((tab) =>
        tab.id === id ? { ...tab, visible: !tab.visible } : tab
      )
    );
  };

  const handleCloseTab3 = (id) => {
    // Update the visibility of the tab
    setTabs3(
      tabs3.map((tab) => (tab.id === id ? { ...tab, visible: false } : tab))
    );

    if (ativeDiv === id) {
      // Find the next visible tab after the current index
      const nextVisibleTab = tabs3.slice(id + 1).find((tab) => tab.visible);

      if (nextVisibleTab) {
        setActiveTab3(nextVisibleTab.id);
        setActiveDiv(nextVisibleTab.id);
      } else {
        // If no visible tab after the current one, find one before it
        const prevVisibleTab = tabs3
          .slice(0, id)
          .reverse()
          .find((tab) => tab.visible);
        if (prevVisibleTab) {
          setActiveTab3(prevVisibleTab.id);
          setActiveDiv(prevVisibleTab.id);
        } else {
          // If no visible tabs at all, set both to null
          setActiveTab3(null);
          setActiveDiv(null);
        }
      }
    }
  };

  useEffect(() => {
    const areAllHidden = tabs3.every((tab) => !tab.visible);
    if (areAllHidden) {
      setActiveDiv(null);
    }
  }, [tabs3]);

  const handleToggleTab3 = (id) => {
    setTabs3(
      tabs3.map((tab) =>
        tab.id === id ? { ...tab, visible: !tab.visible } : tab
      )
    );
  };

  const handleCloseTab4 = (id) => {
    setTabs4(
      tabs4.map((tab) => (tab.id === id ? { ...tab, visible: false } : tab))
    );
  };

  const handleToggleTab4 = (id) => {
    setTabs4(
      tabs4.map((tab) =>
        tab.id === id ? { ...tab, visible: !tab.visible } : tab
      )
    );
  };

  const handleCloseTab5 = (id) => {
    setTabs5(
      tabs5.map((tab) => (tab.id === id ? { ...tab, visible: false } : tab))
    );
    setActiveTab5(1);
  };

  const handleToggleTab5 = (id) => {
    setTabs5(
      tabs5.map((tab) =>
        tab.id === id ? { ...tab, visible: !tab.visible } : tab
      )
    );

    setActiveTab5(0);
  };

  const scrollRef = useRef(null);

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 100, behavior: "smooth" });
    }
  };

  const [showGrid1, setShowGrid1] = useState(true);
  const [showGrid2, setShowGrid2] = useState(true);
  const [showGrid3, setShowGrid3] = useState(true);
  const [showGrid4, setShowGrid4] = useState(true);
  const [showGrid5, setShowGrid5] = useState(true);

  const [outerShowGrid1, setOuterShowGrid1] = useState(true);
  const [outerShowGrid2, setOuterShowGrid2] = useState(true);

  useEffect(() => {
    const savedLayout = localStorage.getItem("layout");

    if (pathname?.includes("future")) {
      setDefLayout("professional");
      handleLayoutType("professional");
    } else if (savedLayout) {
      setDefLayout(savedLayout);
      handleLayoutType(savedLayout);
    }
  }, [matchesXL]);

  useEffect(() => {
    if (pathname.includes("future")) {
      setTabs3((prevTabs) =>
        prevTabs.map((tab) => (tab.id === 4 ? { ...tab, visible: true } : tab))
      );
    } else {
      setTabs3((prevTabs) =>
        prevTabs.map((tab) => (tab.id === 4 ? { ...tab, visible: false } : tab))
      );
    }
  }, [pathname]);

  const DrawerList = (
    <Box
      sx={{ width: 420, p: 1 }}
      role="presentation"
      onClick={toggleDrawerLayout(false)}
    >
      <Box marginBottom={0} sx={{ p: 1, borderBottom: "1px solid #cccccc36" }}>
        <div className="display-2 p-10">
          <div className="select-form">Layout</div>
          <div className="display-1">
            <HighlightOffIcon
              sx={{ fontSize: "25px !important" }}
              className="cursor"
              onClick={toggleDrawerLayout(false)}
            />
          </div>
        </div>
      </Box>
      <div
        className="p-10 mt-20"
        style={{ borderBottom: "1px solid #cccccc36" }}
      >
        <div className="deflayout-h">Default Layout</div>
        <div className="display-3 flex-wrap def-lay-svg">
          <div
            className={
              defLayout === "classic" ? "svg-actv class-name" : "class-name"
            }
            onClick={() => {
              setDefLayout("classic");
              handleLayoutType("classic");
            }}
          >
            <svg
              width="120"
              height="80"
              viewBox="0 0 128 80"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              data-name="classic-dark"
            >
              <rect
                width="128"
                height="80"
                rx="4"
                fill="#F3F3F3"
                fill-opacity="0.08"
              ></rect>
              <rect
                x="6"
                y="6"
                width="116"
                height="68"
                rx="2"
                fill="#121212"
              ></rect>
              <rect
                x="34"
                y="40"
                width="60"
                height="29"
                rx="2"
                fill="#F3F3F3"
                fill-opacity="0.08"
              ></rect>
              <rect
                x="65"
                y="60"
                width="16"
                height="4"
                rx="2"
                fill="#F65454"
              ></rect>
              <rect
                x="47"
                y="60"
                width="16"
                height="4"
                rx="2"
                fill="#01BC8D"
              ></rect>
            </svg>
            <div className="">Classic</div>
          </div>

          <div
            className={
              defLayout === "professional"
                ? "svg-actv class-name"
                : "class-name"
            }
            onClick={() => {
              setDefLayout("professional");
              handleLayoutType("professional");
            }}
          >
            <svg
              width="120"
              height="80"
              viewBox="0 0 128 80"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              data-name="advanced-dark"
            >
              <rect
                width="128"
                height="80"
                rx="4"
                fill="#F3F3F3"
                fill-opacity="0.08"
              ></rect>
              <rect
                x="6"
                y="6"
                width="116"
                height="68"
                rx="2"
                fill="#121212"
              ></rect>
              <rect
                x="91"
                y="11"
                width="26"
                height="58"
                rx="2"
                fill="#F3F3F3"
                fill-opacity="0.08"
              ></rect>
              <rect
                x="96"
                y="16"
                width="7"
                height="4"
                rx="2"
                fill="#01BC8D"
              ></rect>
              <rect
                x="105"
                y="16"
                width="7"
                height="4"
                rx="2"
                fill="#F65454"
              ></rect>
              <rect
                x="96"
                y="44"
                width="16"
                height="4"
                rx="2"
                fill="#01BC8D"
              ></rect>
            </svg>
            <div className="">Professional</div>
          </div>

          <div
            className={
              defLayout === "fullscreen" ? "svg-actv class-name" : "class-name"
            }
            onClick={() => {
              setDefLayout("fullscreen");
              handleLayoutType("fullscreen");
            }}
          >
            <svg
              width="120"
              height="80"
              viewBox="0 0 128 80"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              data-name="fullscreen-dark"
            >
              <rect
                width="128"
                height="80"
                rx="4"
                fill="#F3F3F3"
                fill-opacity="0.08"
              ></rect>
              <rect
                x="6"
                y="6"
                width="116"
                height="68"
                rx="2"
                fill="#121212"
              ></rect>
              <rect
                x="69"
                y="40"
                width="48"
                height="29"
                rx="2"
                fill="#F3F3F3"
                fill-opacity="0.08"
              ></rect>
              <rect
                x="94"
                y="60"
                width="16"
                height="4"
                rx="2"
                fill="#F65454"
              ></rect>
              <rect
                x="76"
                y="60"
                width="16"
                height="4"
                rx="2"
                fill="#01BC8D"
              ></rect>
            </svg>
            <div className="">Full Screen</div>
          </div>
        </div>
        <div className="deflayout-h mt-20">Custom Layout</div>
        <div className="  def-lay-svg ">
          <div
            className={"custm-lay"}
            onClick={() => setDefLayout("fullscreen")}
          >
            <div className="cust-svg">
              <AddCircleOutlineIcon sx={{ color: "#cccccc36" }} />
            </div>
            <div className="class-name mt-10">Create</div>
          </div>
        </div>
      </div>

      <div className="p-10 mt-20">
        <div className="display-2">
          <div className="deflayout-h" style={{ textTransform: "capitalize" }}>
            {defLayout}
          </div>
          <div
            className="deflayout-h cursor"
            style={{ textTransform: "capitalize", color: "#566FFF" }}
            onClick={() => {
              restoreDefaults();
            }}
          >
            Restore to Default
          </div>
        </div>
      </div>
      <Box marginBottom={2} sx={{ px: 1 }}>
        {tabs.map((tab, i) => (
          <Box
            key={tab.id}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            marginBottom={1}
          >
            <Typography className="tab-lab">{tab.label}</Typography>

            <FormControlLabel
              checked={tab.visible}
              control={
                <AntSwitch
                  sx={{ my: 2, mx: 1 }}
                  defaultChecked
                  onChange={() => {
                    handleToggleTab(tab.id);
                    handleLayoutIndex(i, tab.visible);
                  }}
                />
              }
            // label="iOS style"
            />
          </Box>
        ))}
      </Box>
      <Box marginBottom={2} sx={{ px: 1 }}>
        {tabs2.map((tab, i) => (
          <Box
            key={tab.id}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            marginBottom={1}
          >
            <Typography className="tab-lab">{tab.label}</Typography>

            <FormControlLabel
              checked={tab.visible}
              control={
                <AntSwitch
                  sx={{ my: 2, mx: 1 }}
                  defaultChecked
                  onChange={() => {
                    handleToggleTab2(tab.id);
                    handleLayoutIndex2(i, tab.visible);
                  }}
                />
              }
            />
          </Box>
        ))}
      </Box>
      <Box marginBottom={2} sx={{ px: 1 }}>
        {tabs3.map((tab, i) => (
          <Box
            key={tab.id}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            marginBottom={1}
          >
            <Typography className="tab-lab">{tab.label}</Typography>

            <FormControlLabel
              checked={tab.visible}
              control={
                <AntSwitch
                  sx={{ my: 2, mx: 1 }}
                  defaultChecked
                  onChange={() => {
                    handleToggleTab3(tab.id);
                    handleLayoutIndex3(i, tab.id);
                  }}
                />
              }
            />
          </Box>
        ))}
      </Box>
      <Box marginBottom={2} sx={{ px: 1 }}>
        {tabs4.map((tab) => (
          <Box
            key={tab.id}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            marginBottom={1}
          >
            <Typography className="tab-lab"> {tab.label}</Typography>

            <FormControlLabel
              checked={tab.visible}
              control={
                <AntSwitch
                  sx={{ my: 2, mx: 1 }}
                  defaultChecked
                  onChange={() => handleToggleTab4(tab.id)}
                />
              }
            />
          </Box>
        ))}
      </Box>
      <Box marginBottom={2} sx={{ px: 1 }}>
        {tabs5.map((tab) => (
          <Box
            key={tab.id}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            marginBottom={1}
          >
            <Typography className="tab-lab">{tab.label}</Typography>
            <FormControlLabel
              checked={tab.visible}
              control={
                <AntSwitch
                  sx={{ my: 2, mx: 1 }}
                  defaultChecked
                  onChange={() => handleToggleTab5(tab.id)}
                />
              }
            // label="iOS style"
            />
          </Box>
        ))}
      </Box>
    </Box>
  );

  // Function to reset all tabs to visible (true)
  const restoreDefaults = () => {
    setTabs(tabs.map((tab) => ({ ...tab, visible: true })));
    setTabs2(tabs2.map((tab) => ({ ...tab, visible: true })));
    setTabs3(tabs3.map((tab) => ({ ...tab, visible: true })));
    setTabs4(tabs4.map((tab) => ({ ...tab, visible: true })));
    setTabs5(tabs5.map((tab) => ({ ...tab, visible: true })));
  };

  // Check if all tabs are hidden
  useEffect(() => {
    const allHidden = tabs.every((tab) => !tab.visible);
    const allHidden2 = tabs2.every((tab) => !tab.visible);
    const allHidden3 = tabs3.every((tab) => !tab.visible);
    const allHidden4 = tabs4.every((tab) => !tab.visible);
    const allHidden5 = tabs5.every((tab) => !tab.visible);

    if (allHidden) {
      setShowGrid1(false);
    } else {
      setShowGrid1(true);
    }

    if (allHidden2) {
      setShowGrid2(false);
    } else {
      setShowGrid2(true);
    }

    if (allHidden3) {
      setShowGrid3(false);
    } else {
      setShowGrid3(true);
    }
    if (allHidden4) {
      setShowGrid4(false);
    } else {
      setShowGrid4(true);
    }
    if (allHidden5) {
      setShowGrid5(false);
    } else {
      setShowGrid5(true);
    }

    if (allHidden && allHidden2 && allHidden3) {
      setOuterShowGrid1(false);
    } else {
      setOuterShowGrid1(true);
    }

    if (allHidden4 && allHidden5) {
      setOuterShowGrid2(false);
    } else {
      setOuterShowGrid2(true);
    }
  }, [tabs, tabs2, tabs3, tabs4, tabs5]);

  const {
    setOpenPositions,
    setOpenPositionsData,
    setCurrentOrders,
    setCurrentOrdersData,
  } = useContext(Context);

  const openOrderSocket = async () => {
    try {
      setLoad(true);
      var socket = "";
      if (consts?.type == "Production") {
        socket = io(`${consts?.socketUrl}`, { path: "/socket" }); // for Live
      } else {
        socket = io(`${consts?.socketUrl}`); // for local
      }

      socket.on("connect", () => {
        const request = {
          userId: localStorage.getItem("use"),
          type: placeRoute,
        };
        // console.log(request, "requestrequest")
        socket.emit("getOpenOrders", request);
      });

      socket.on("getOpenOrders", (data) => {
        if (data?.success) {
          setOpenPositionsData(data?.position);
          setCurrentOrdersData(data?.data);
          setOpenPositions(data?.position?.length ? data?.position?.length : 0);
          setCurrentOrders(data?.data?.length ? data?.data?.length : 0);
          setLoad(false);
        } else {
          setOpenPositionsData([]);
          setOpenPositions(0);
          console.log("Error:", data?.message);
          setLoad(false);
        }
      });
      socket.on("disconnect", () => {
        console.log("Disconnected from backend WebSocket");
      });
      setLoad(false);
    } catch (error) {
      console.log("🚀 ~ getOpenOrdersSocket ~ error:", error);
      setLoad(false);
    }
  };

  useEffect(() => {
    if (localStorage.getItem("use")) {
      openOrderSocket();
    }
  }, []);

  return (
    <Box sx={{ width: "100%" }}>
      <Header />
      <ToastContainer />
      {load && <Loader />}
      <Drawer
        anchor="right"
        open={openLayout}
        onClose={toggleDrawerLayout(false)}
        className="layout-draw"
      >
        {DrawerList}
      </Drawer>
      <Grid container>
        <Grid xs={12} sm={12} md={12} lg={12} xl={12} className="">
          <div className="padding-10 grid-box">
            <div className="display-2">
              <div
                className="display-1"
                style={{
                  gap: !mobilemd ? "20px" : "40px",
                  overflowY: !mobilemd && "scroll",
                  paddingLeft: mobilemd ? "15px" : "0px",
                }}
              >
                <div
                  className="select-form display-1 cursor"
                  onClick={() => {
                    handleOpenCoinPair();
                    fetchPairsList("", "runs");
                  }}
                >
                  <Drop />
                  <ImageWithFallback
                    src={`${consts?.imageurl}${id?.split("_")[0]}.png`}
                    alt="Btcoin"
                    className="Btcoin"
                    name={currentPair}
                    size={20}
                  />
                  <div>{currentPair?.split("_")?.join("/")}</div>
                </div>
                <div
                  className="display-5"
                  style={{
                    gap: "30px",
                    width: "auto",
                    overflowY: !sm && "scroll",
                  }}
                >
                  <div className="total-data">
                    Price
                    <div className="total-sub">
                      <span
                        className={`prices-${currentPair
                          ?.split("_")
                          ?.join("")}M`}
                      >
                        -
                      </span>
                    </div>
                  </div>

                  <div className="lh-24">
                    24h change
                    <div className="lh-sub" style={{ color: "#f66754" }}>
                      <span
                        className={`24hpc-${currentPair
                          ?.split("_")
                          ?.join("")}M`}
                      >
                        -
                      </span>
                    </div>
                  </div>
                  <div className="lh-24">
                    24h High
                    <div className="lh-sub">
                      <span
                        className={`high-${currentPair?.split("_")?.join("")}M`}
                      >
                        -
                      </span>
                    </div>
                  </div>

                  <div className="lh-24">
                    24h Low
                    <div className="lh-sub">
                      <span
                        className={`low-${currentPair?.split("_")?.join("")}M`}
                      >
                        -
                      </span>
                    </div>
                  </div>

                  <div className="lh-24">
                    24h volume
                    <div className="lh-sub">
                      <span
                        className={`vol-${currentPair?.split("_")?.join("")}M`}
                      >
                        -
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="display-1" style={{ gap: "20px" }}>
                {/* <div className="display-1 lh-sub">
                  <Msg />
                  News
                </div> */}

                {/* <div className="display-1 lh-sub">
                  <Trading />
                  Trading Info
                </div> */}

                {/* <div className="hoz-des"></div> */}
                {/* <div className="">
                  <M1 />
                </div> */}

                {/* <div onClick={toggleDrawerLayout(true)} className="cursor" style={{ display: !matchesXL && 'none' }}>
                  <M2 />
                </div> */}
                {/* <div className="">
                  <M3 />
                </div> */}
              </div>
            </div>
          </div>
        </Grid>
        <Grid xs={12} sm={12} md={12} lg={12} xl={12} className="">
          {!mobilemd && (
            <>
              <div className="display-2  c-stick">
                Candle Stick
                <div onClick={handleCandle}>
                  <CandlestickChartIcon sx={{ fontSize: "22px !important" }} />
                </div>
              </div>

              <Collapse
                in={candle}
                timeout="auto"
                unmountOnExit
                className="c-stick-cp"
              >
                <List component="div" disablePadding>
                  <ListItemButton sx={{ pl: 4 }}>
                    <Tradeview
                      classic={classic}
                      fullScreen={fullScreen}
                      pair={currentPair}
                    />
                  </ListItemButton>
                </List>
              </Collapse>
            </>
          )}
        </Grid>
        {outerShowGrid1 && (
          <Grid item xl={10} lg={9} md={8} sm={12} xs={12}>
            <Grid container>
              {classic && classicGleft && (
                <Grid order={classic ? 1 : null} xl={showGrid1 ? 3 : 12}>
                  {
                    <>
                      {classicMark && (
                        <>
                          <button
                            className={"btn-s-order display-1 active p-10"}
                          >
                            Market
                            <CloseIcon
                              fontSize="small"
                              sx={{ fill: "#ccc" }}
                              onClick={(e) => {
                                e.stopPropagation();
                                // handleCloseTab5(tab.id);
                                setClassicMark(false);
                              }}
                            />
                          </button>
                          <Box sx={{ width: "100%", p: 0 }}>
                            <Box sx={{ margin: "10px 0", p: 0 }}>
                              <Tabs
                                value={valueTab2}
                                onChange={handleChangeTab2}
                                aria-label="basic tabs example"
                                className="tabs-trade"
                              >
                                <Tab label="spot" {...a11yProps(0)} />
                                <Tab label="Margin" {...a11yProps(2)} />
                              </Tabs>
                            </Box>

                            <CustomTabPanel
                              value={valueTab2}
                              index={0}
                              className="cust-box"
                              sx={{ "&.MuiBox-root": { p: 0 } }}
                            >
                              <Box sx={{ width: "100%", p: 0 }}>
                                <Box>
                                  <Tabs
                                    value={value7}
                                    onChange={handleChange7}
                                    aria-label="basic tabs example"
                                    className="tabs-trade"
                                  >
                                    <Tab label="USDT" {...a11yProps(0)} />
                                    <Tab label="USDC" {...a11yProps(1)} />
                                    <Tab label="BTC" {...a11yProps(2)} />
                                    <Tab label="ETH" {...a11yProps(3)} />
                                  </Tabs>
                                </Box>

                                <CustomTabPanel className="cust-box">
                                  <TableContainer className="trade-left-table model">
                                    <Table
                                      aria-label="simple table"
                                      stickyHeader
                                    >
                                      <TableHead>
                                        <TableRow>
                                          <TableCell align="left">
                                            {" "}
                                            Trading Pairs/Vol{" "}
                                          </TableCell>
                                          <TableCell align="right">
                                            Price
                                          </TableCell>
                                          <TableCell align="right">
                                            24H Change
                                          </TableCell>
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        {pairsList?.length > 0 &&
                                          pairsList?.map((row, ind) => (
                                            <TableRow
                                              key={ind}
                                              sx={{
                                                "&:last-child td, &:last-child th":
                                                  { border: 0 },
                                              }}
                                              onClick={() => {
                                                // window.location.href = `/${placeRoute}/${row?.baseCoin}_${row?.quoteCoin}`
                                                navigate(
                                                  `/${placeRoute}/${row?.base_asset_name}_${row?.market_asset_name}`
                                                );
                                                handleCloseCoinPair();
                                                handleSidebarUnsubscribe();
                                              }}
                                            // className={
                                            //   ind > midpoint ? "tr-green" : "tr-green"
                                            // }
                                            >
                                              <TableCell
                                                component="th"
                                                scope="row"
                                                align="left"
                                              >
                                                <div
                                                  className="select-form display-1 cursor"
                                                  onClick={() => {
                                                    handleOpenCoinPair();
                                                    localStorage.setItem(
                                                      "pairUrl",
                                                      row?.imageurl
                                                    );
                                                  }}
                                                >
                                                  <img
                                                    src={
                                                      row?.imageurl
                                                        ? row?.imageurl
                                                        : `${consts?.imageurl}${row?.base_asset_name}.png`
                                                    }
                                                    alt="Btcoin"
                                                    className="Btcoin"
                                                  />
                                                  {`${row?.base_asset_name}/${row?.market_asset_name}`}
                                                </div>
                                              </TableCell>

                                              <TableCell
                                                component="th"
                                                scope="row"
                                                align="right"
                                              >
                                                <span
                                                  className={`price-${row?.pair_symbol
                                                    ?.split("_")
                                                    ?.join("")}`}
                                                >
                                                  0
                                                </span>
                                                {/* {row?.price} */}
                                              </TableCell>
                                              <TableCell
                                                component="th"
                                                scope="row"
                                                align="right"
                                              >
                                                <span
                                                  className={`24hrchange-${row?.pair_symbol
                                                    ?.split("_")
                                                    ?.join("")}`}
                                                >
                                                  0
                                                </span>
                                              </TableCell>
                                            </TableRow>
                                          ))}
                                        {pairsLoading == true ? (
                                          <TableRow>
                                            <TableCell colSpan={8}>
                                              <div className="model-load">
                                                <Loader />
                                              </div>
                                            </TableCell>
                                          </TableRow>
                                        ) : (
                                          pairsList?.length == 0 && (
                                            <TableRow>
                                              <TableCell colSpan={8}>
                                                <div
                                                  className="model-load"
                                                  style={{
                                                    color: "white",
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  No Pair Found
                                                </div>
                                              </TableCell>
                                            </TableRow>
                                          )
                                        )}
                                      </TableBody>
                                    </Table>
                                  </TableContainer>
                                </CustomTabPanel>
                              </Box>
                            </CustomTabPanel>
                          </Box>
                          <button
                            className={"btn-s-order display-1 active p-10"}
                          >
                            Asset OverView
                            {/* <CloseIcon fontSize="small" sx={{ fill: "#ccc" }} onClick={(e) => {
                        e.stopPropagation();
                        handleCloseTab5(tab.id);
                        setClassicAsset(false)
                      }} /> */}
                          </button>
                          <AssetView />
                        </>
                      )}
                    </>
                  }
                </Grid>
              )}
              {showGrid1 && (
                <Grid
                  // order={professional || fullScreen ? 1 : 2}
                  item
                  xl={9.5}
                  lg={8}
                  md={7}
                  sm={6}
                  xs={6}
                  sx={{ bgcolor: "var(--clr-bcg)" }}
                >
                  {mobilemd && (
                    <Tabs
                      aria-label="Dynamic Tabs"
                      className="dynamic-tab"
                      value={activeTab}
                      onChange={handleTabChange}
                    >
                      {tabs
                        .filter((tab) => tab.visible)
                        .map((tab) => (
                          <Tab
                            key={tab.id}
                            label={
                              <Box display="flex" alignItems="center">
                                {tab.label}
                                <IconButton
                                  size="small"
                                  // onClick={(e) => {
                                  //   e.stopPropagation();
                                  //   handleCloseTab(tab.id);
                                  //   handleTabMath(tab.id);
                                  // }}
                                  sx={{
                                    marginLeft: 1,
                                    display: matchesXL ? "inline-flex" : "none",
                                  }}
                                >
                                  {/* <CloseIcon fontSize="small" sx={{ fill: "#fff" }} /> */}
                                </IconButton>
                              </Box>
                            }
                          />
                        ))}
                    </Tabs>
                  )}
                  {/* <div className="mt-5"></div> */}
                  {mobilemd && activeTab === 0 ? (
                    <Tradeview
                      classic={classic}
                      fullScreen={fullScreen}
                      pair={currentPair}
                    />
                  ) : (
                    // <Tradeview classic={classic} fullScreen={fullScreen} />
                    // <div className="">hiii</div>
                    ""
                  )}
                  {classic && (
                    <>
                      <button className={"btn-s-order display-1 active p-10"}>
                        PlaceOrder
                        {/* <CloseIcon fontSize="small" sx={{ fill: "#ccc" }} onClick={(e) => {
                        e.stopPropagation();
                        handleCloseTab5(tab.id);
                        setClassicMark(false)
                      }} /> */}
                      </button>
                      <Placeorder classic={classic} />
                    </>
                  )}
                  {!mobilemd && <Placeorder classic={classic} />}
                </Grid>
              )}
              {showGrid2 && (
                <Grid
                  // order={professional || fullScreen ? 2 : 3}
                  item
                  xl={2.5}
                  lg={4}
                  md={5}
                  sm={6}
                  xs={6}
                  sx={{ bgcolor: "var(--clr-bcg)" }}
                >
                  <Tabs
                    value={activeTab2}
                    aria-label="Dynamic Tabs"
                    className="dynamic-tab"
                    onChange={handleTabChange2}
                    sx={{ ml: 1 }}
                  >
                    {tabs2
                      .filter((tab) => tab.visible)
                      .map((tab) => (
                        <Tab
                          key={tab.id}
                          label={
                            <Box display="flex" alignItems="center">
                              {tab.label}
                              <IconButton
                                size="small"
                                // onClick={(e) => {
                                //   e.stopPropagation();
                                //   handleCloseTab2(tab.id);
                                //   handleTabMath2(tab.id);
                                // }}
                                sx={{
                                  marginLeft: 1,
                                  display: matchesXL ? "inline-flex" : "none",
                                }}
                              >
                                {/* <CloseIcon fontSize="small" sx={{ fill: "#fff" }} /> */}
                              </IconButton>
                            </Box>
                          }
                        />
                      ))}
                  </Tabs>
                  {activeTab2 === 0 ? (
                    <OrderBook
                      order={activeTab2}
                      fullScreen={fullScreen}
                      classic={classic}
                      pair={currentPair}
                    />
                  ) : (
                    <OrderBook
                      order={activeTab2}
                      fullScreen={fullScreen}
                      classic={classic}
                    />
                  )}
                </Grid>
              )}
              {showGrid3 && (
                <Grid
                  // order={4}
                  item
                  xl={12}
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  sx={{ bgcolor: "var(--clr-bcg)" }}
                >
                  <>
                    <div
                      className="display-1 mt-10"
                      style={{ whiteSpace: "nowrap", overflowX: "scroll" }}
                      ref={scrollRef}
                    >
                      {tabs3.map((tab, i) => {
                        return (
                          tab?.visible && (
                            <>
                              <button
                                key={i}
                                onClick={() => {
                                  setActiveTab3(i);
                                  setActiveDiv(i);
                                }}
                                className={
                                  i === activeTab3
                                    ? "btn-s-order display-1 active"
                                    : "btn-s-order display-1"
                                }
                              >
                                {tab.label == "current orders"
                                  ? `current orders(${currentOrders})`
                                  : tab.label == "Positions"
                                    ? `Positions(${openPositions})`
                                    : tab?.label}
                                {/* <CloseIcon fontSize="small" sx={{ fill: "#ccc", display: matchesXL ? 'inline-flex' : 'none' }} onClick={(e) => {
                              e.stopPropagation();
                              handleCloseTab3(tab.id);
                            }} /> */}
                              </button>
                            </>
                          )
                        );
                      })}

                      <ChevronRightIcon
                        sx={{ display: !mobilemd ? "block" : "none" }}
                        className="scroll-btn"
                        onClick={scrollRight}
                      />
                    </div>
                    <div className="history_tabs" style={{ width: "100%" }}>
                      <div className="history_content">
                        {/* {tradeComp.includes(tradeComp[activeTab3]) && tradeComp[activeTab3]} */}
                        {ativeDiv != null &&
                          tradeComp[ativeDiv]?.visible &&
                          tradeComp[ativeDiv]?.label}

                        {/* {activeComponents.map((comp, index) => (
          <div key={index} style={{ marginBottom: "10px" }}>
            {comp}
          </div>
        ))} */}
                      </div>
                    </div>
                    {fullScreen && (
                      <>
                        <button className={"btn-s-order display-1 active p-10"}>
                          Asset OverView
                          {/* <CloseIcon fontSize="small" sx={{ fill: "#ccc" }} onClick={(e) => {
                          e.stopPropagation();
                          handleCloseTab5(tab.id);
                          setClassicMark(false)
                        }} /> */}
                        </button>
                        <AssetView />
                      </>
                    )}
                  </>
                </Grid>
              )}

              {(fullScreen || classic) && (
                <Grid
                  order={classic ? 3 : 5}
                  item
                  xl={fullScreen ? 4 : 3}
                  lg={fullScreen ? 4 : 3}
                  sx={{ bgcolor: "var(--clr-bcg)" }}
                >
                  {fullScreen && (
                    <>
                      <button className={"btn-s-order display-1 active p-10"}>
                        PlaceOrder
                        {/* <CloseIcon fontSize="small" sx={{ fill: "#ccc" }} onClick={(e) => {
                      e.stopPropagation();
                      handleCloseTab5(tab.id);
                      setClassicMark(false)
                    }} /> */}
                      </button>
                      <Placeorder fullScreen={fullScreen} />
                    </>
                  )}
                </Grid>
              )}
            </Grid>
          </Grid>
        )}
        {professional && outerShowGrid2 && (
          <Grid item xl={2} lg={3} md={4} sm={12} xs={12}>
            {
              <Grid container sx={{ height: "100%" }}>
                {showGrid4 && (
                  <Grid item xl={12} sx={{ bgcolor: "var(--clr-bcg)" }} md={12}>
                    {mobilemd && (
                      <div className="display-1 mt-5">
                        {tabs4.map((tab, i) => {
                          return (
                            tab?.visible && (
                              <button
                                key={i}
                                onClick={() => {
                                  setActiveTab4(i);
                                }}
                                className={
                                  i === activeTab4
                                    ? "btn-s-order display-1 active"
                                    : "btn-s-order display-1"
                                }
                              >
                                {tab.label}
                                {/* <CloseIcon fontSize="small" sx={{ fill: "#ccc", display: matchesXL ? 'inline-flex' : 'none' }} onClick={(e) => {
                        e.stopPropagation();
                        handleCloseTab4(tab.id);

                      }} /> */}
                              </button>
                            )
                          );
                        })}
                      </div>
                    )}

                    {mobilemd && (
                      <div className="mt-20">
                        {activeTab4 === 0 && <Placeorder />}
                      </div>
                    )}
                  </Grid>
                )}
                {showGrid5 && mobilemd && (
                  <Grid
                    item
                    xl={12}
                    sx={{ bgcolor: "var(--clr-bcg)" }}
                    md={12}
                    className="flex-c-end"
                  >
                    <div className="display-1 mt-10">
                      {tabs5.map((tab, i) => {
                        return (
                          tab?.visible && (
                            <button
                              key={i}
                              onClick={() => {
                                setActiveTab5(i);
                              }}
                              className={
                                i === activeTab5
                                  ? "btn-s-order display-1 active"
                                  : "btn-s-order display-1"
                              }
                            >
                              {tab.label}
                              {/* <CloseIcon fontSize="small" sx={{ fill: "#ccc", display: matchesXL ? 'inline-flex' : 'none' }} onClick={(e) => {
                        e.stopPropagation();
                        handleCloseTab5(tab.id);
                      }} /> */}
                            </button>
                          )
                        );
                      })}
                    </div>

                    {activeTab5 === 0 && <AssetView />}
                  </Grid>
                )}
              </Grid>
            }
          </Grid>
        )}
      </Grid>
      <Modal
        open={openCoinPair}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
        className="modal-box-cnt"
      >
        <Slide in={openCoinPair} direction="right">
          <Box sx={{ ...style }} className="modal-trade">
            <div className="text-right">
              <HighlightOffIcon
                sx={{ fill: "var(--clr-font)", cursor: "pointer" }}
                onClick={() => {
                  // handleSearch("");
                  handleCloseCoinPair();
                  handleSidebarUnsubscribe();
                }}
              />
            </div>
            <div className="mt-10">
              <div class="group">
                <svg viewBox="0 0 24 24" aria-hidden="true" class="search-icon">
                  <g>
                    <path d="M21.53 20.47l-3.66-3.66C19.195 15.24 20 13.214 20 11c0-4.97-4.03-9-9-9s-9 4.03-9 9 4.03 9 9 9c2.215 0 4.24-.804 5.808-2.13l3.66 3.66c.147.146.34.22.53.22s.385-.073.53-.22c.295-.293.295-.767.002-1.06zM3.5 11c0-4.135 3.365-7.5 7.5-7.5s7.5 3.365 7.5 7.5-3.365 7.5-7.5 7.5-7.5-3.365-7.5-7.5z"></path>
                  </g>
                </svg>

                <input
                  onChange={(e) => handleSearch(e.target.value)}
                  id="query"
                  class="input"
                  type="search"
                  placeholder="Search..."
                  name="searchbar"
                />
              </div>
            </div>
            <Box sx={{ width: "100%" }}>
              {placeRoute != "future" && (
                <Box sx={{ margin: "10px 0" }}>
                  <Tabs
                    value={valueTab2}
                    onChange={handleChangeTab2}
                    aria-label="basic tabs example"
                    className="tabs-trade"
                  >
                    <Tab label="spot" {...a11yProps(0)} />
                    <Tab label="Margin" {...a11yProps(2)} />
                  </Tabs>
                </Box>
              )}

              <CustomTabPanel value={valueTab2} index={0}>
                <Box sx={{ width: "100%" }}>
                  <Box>
                    <Tabs
                      value={value7}
                      onChange={handleChange7}
                      aria-label="basic tabs example"
                      className="tabs-trade"
                    >
                      <Tab label="USDT" {...a11yProps(0)} />
                      {placeRoute != "future" && (
                        <>
                          <Tab label="USDC" {...a11yProps(1)} />
                          <Tab label="BTC" {...a11yProps(2)} />
                          <Tab label="ETH" {...a11yProps(3)} />
                        </>
                      )}
                    </Tabs>
                  </Box>

                  <CustomTabPanel className="cust-box">
                    <TableContainer className="trade-left-table model">
                      <Table aria-label="simple table" stickyHeader>
                        <TableHead>
                          <TableRow>
                            <TableCell align="left">
                              {" "}
                              Trading Pairs/Vol{" "}
                            </TableCell>
                            <TableCell align="right">Price</TableCell>
                            <TableCell align="right">24H Change</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {pairsList?.length > 0 &&
                            pairsList?.map((row, ind) => (
                              <TableRow
                                key={ind}
                                sx={{
                                  "&:last-child td, &:last-child th": {
                                    border: 0,
                                  },
                                }}
                                onClick={() => {
                                  // window.location.href = `/${placeRoute}/${row?.baseCoin}_${row?.quoteCoin}`
                                  navigate(
                                    `/${placeRoute}/${row?.base_asset_name}_${row?.market_asset_name}`
                                  );
                                  setPointFilter(
                                    countDecimals(row?.pointFilter)
                                  );
                                  // console.log(
                                  //   countDecimals(row?.pointFilter),
                                  //   "trade 2"
                                  // );
                                  handleCloseCoinPair();
                                  handleSidebarUnsubscribe();
                                  // handleSearch("");
                                }}
                              // className={
                              //   ind > midpoint ? "tr-green" : "tr-green"
                              // }
                              >
                                <TableCell
                                  component="th"
                                  scope="row"
                                  align="left"
                                >
                                  <div
                                    className="select-form display-1 cursor"
                                    onClick={() => {
                                      handleOpenCoinPair();
                                      localStorage.setItem(
                                        "pairUrl",
                                        row?.imageurl
                                      );
                                      setSelcOrderBook([0]);
                                    }}
                                  >
                                    {/* <img src={row?.imageurl ? row?.imageurl : `${consts?.imageurl}${row?.base_asset_name}.png`} alt="Btcoin" className='Btcoin' /> */}
                                    {/* {`${row?.base_asset_name}/${row?.market_asset_name}`} */}

                                    <ImageWithFallback
                                      src={
                                        row?.imageurl
                                          ? row?.imageurl
                                          : `${consts?.imageurl}${row?.base_asset_name}.png`
                                      }
                                      name={row?.base_asset_name}
                                      alt="img"
                                    />

                                    <div>
                                      {row?.base_asset_name}/
                                      <span style={{ color: "#706c6c" }}>
                                        {row?.market_asset_name}
                                      </span>
                                    </div>

                                    {/* {`${row?.base_asset_name}/${}`} */}
                                  </div>
                                </TableCell>

                                <TableCell
                                  component="th"
                                  scope="row"
                                  align="right"
                                >
                                  <span
                                    className={`price-${row?.pair_symbol
                                      ?.split("_")
                                      ?.join("")}M`}
                                  >
                                    {row?.last}
                                  </span>
                                  {/* {row?.price} */}
                                </TableCell>
                                <TableCell
                                  component="th"
                                  scope="row"
                                  align="right"
                                >
                                  <span
                                    className={`24hrchange-${row?.pair_symbol?.split("_")?.join("") +
                                      "M"
                                      } ${Number(row?.changeRate) * 100 >= 0
                                        ? "tr-green"
                                        : "tr-red"
                                      }`}
                                  >
                                    {(Number(row?.changeRate) * 100)?.toFixed(2)} %
                                  </span>
                                </TableCell>
                              </TableRow>
                            ))}
                          {pairsLoading == true ? (
                            <TableRow>
                              <TableCell colSpan={8}>
                                <div className="model-load">
                                  <Loader />
                                </div>
                              </TableCell>
                            </TableRow>
                          ) : (
                            pairsList?.length == 0 && (
                              <TableRow>
                                <TableCell colSpan={8}>
                                  <div
                                    className="model-load"
                                    style={{
                                      color: "white",
                                      textAlign: "center",
                                    }}
                                  >
                                    No Pair Found
                                  </div>
                                </TableCell>
                              </TableRow>
                            )
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </CustomTabPanel>
                </Box>
              </CustomTabPanel>
            </Box>
          </Box>
        </Slide>
      </Modal>
    </Box>
  );
};

export default Trade2;
